<template>
  <div
    class="w-100 d-flex flex-column gap-4 justify-center align-center my-10"
    data-testid="yard-no-areas-message">
    <span class="icon-wrapper">
      <v-icon class="icon" size="50" color="#9E9E9E">mdi-warehouse</v-icon>
    </span>
    <div style="max-inline-size: 270px; text-align: center">
      <h3 class="typography-body-md-bold align-center">
        {{ t('yard.messages.dontHaveAWarehouseYet') }}
      </h3>
      <p class="typography-body-sm m-0">
        {{ t('yard.messages.toCreateAYardViewYouFirstNeedToAddAWarehouseToYourOrganization') }}
      </p>
    </div>
    <p class="typography-body-sm m-0">
      {{ t('yard.messages.goToThe') }}
      <router-link class="typography-body-sm-bold" to="warehouses">
        {{ t('global.specialtyTerms.warehouses', 2) }}
      </router-link>
      page.
    </p>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewNoWarehouse',
  setup() {
    const { t } = useI18n();

    return { t };
  }
});
</script>

<style lang="scss" scoped>
.icon-wrapper {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  inline-size: 96px;
  block-size: 96px;

  border: 1px solid $color-line-border;
  border-radius: 50%;
  background-color: $color-neutral-20;
}
</style>
